import  React,{useEffect, useState} from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import ForgotPassword from "./component/auth/ForgotPassword";
import Login from "./component/auth/Login";
import Otp from "./component/auth/Otp";
import ResetPassword from "./component/auth/ResetPassword";
import Dashboard from "./component/dashboard/Dashboard";
import DeliveryList from "./component/delivery/DeliveryList";
import {getTokenSuccess} from '../src/redux/reducer/FetchDataReducer'
import NavMenu from "./component/header/NavMenu";
import PublicRoute from "./utils/PublicRoute";
import PrivateRoute from "./utils/PrivateRoute";
import OrderDetails from "./component/delivery/OrderDetails";
import Profile from "./component/profile/Profile";
import Earning from "./component/earning/Earning";



function App() {
 var token = useSelector((state) => state.FetchDataReducer.token);
  var token = localStorage.getItem('access_token');


  return (
    <div className="App">
      <BrowserRouter >
      {token &&
      <NavMenu/>
    }
    
      <Routes>
     
      <Route element={<PrivateRoute />}> 
           <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/otp" element={<Otp />} />
            <Route path="/reset-password" element={<ResetPassword />} />
   </Route> 

   <Route element={<PublicRoute />}> 
           <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/delevery-history" element={<DeliveryList />} />
            <Route path="/order-details/:id" element={<OrderDetails />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/earning" element={<Earning />} />
   </Route> 
          
         
            
      </Routes>
      </BrowserRouter>
    </div>
    
  );
}

export default App;
